export const URL_PATTERN =
  // eslint-disable-next-line sonarjs/duplicates-in-character-class -- Disabled for plugin version update. Fix when possible
  /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,15}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/;

// eslint-disable-next-line sonarjs/duplicates-in-character-class -- Disabled for plugin version update. Fix when possible
export const PATH_PATTERN = /^[-a-zA-Z0-9%_+.~#?&//=]+$/;

export const URL_AND_MAILTO_PATTERN =
  // eslint-disable-next-line sonarjs/slow-regex, sonarjs/regex-complexity -- Disabled for plugin version update. Fix when possible
  /(^mailto:(?!.*\.\.)[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)|(^https?:\/\/(?!.*\.\.)[-a-zA-Z0-9_]+\.[a-zA-Z0-9-.]+[^ ]*$)/;
